import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import NotificationsIcon from "@mui/icons-material/Notifications";

interface ToastProps {
  title: string;
  message: string;
  onClose: () => void;
  onClick?: () => void;
}

export const Toast: React.FC<ToastProps> = ({
  title,
  message,
  onClose,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
      setTimeout(() => onClose(), 0);
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        backgroundColor: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        borderRadius: "8px",
        padding: "16px",
        minWidth: "320px",
        maxWidth: "400px",
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        cursor: onClick ? "pointer" : "default",
        transition: "transform 0.2s ease",
        "&:hover": onClick
          ? {
              transform: "translateY(-2px)",
              boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
            }
          : {},
      }}
    >
      <NotificationsIcon sx={{ color: "#1976d2", mt: 0.5 }} />
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="subtitle1"
          sx={{ fontWeight: 600, mb: 0.5, color: "#333" }}
        >
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: "#666" }}>
          {message}
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        sx={{ mt: -0.5, mr: -0.5 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
